<template>
  <div class="table-list" v-loading="loading">
    <div class="table-content">
      <!-- 表格数据 -->
      <el-table :data="listData" header-cell-class-name="dark" :height="tableHeight" stripe border>
        <table-column label="序号" width="60" type="index"></table-column>
        <table-column prop="merId" label="商户名称" />
        <table-column prop="merName" label="商户号" />
        <table-column prop="corpName" label="法人姓名" />
        <table-column prop="corpPhone" label="联系方式" />
        <table-column prop="comName" label="收单机构" />
        <table-column prop="serName" label="城市服务商" />
        <table-column prop="expandUserName" label="渠道" />
        <table-column prop="feedTime" label="账单日" />
        <table-column prop="reviewTime" label="最后还款日" />
        <table-column prop="approveTime" label="授信额度" />
        <table-column prop="channelName" label="平台额度" />
        <table-column prop="manualReview" label="调控时间" />
        <table-column prop="quota" label="操作人" />
      </el-table>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/dataListHeight.js'
export default {
  mixins: [mixin],
  props: {
    listData: {
      type: Array,
      default() {
        return []
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/tableList.scss';
</style>
